"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_CONVERSION_V3_PQ_LINE_SIZE_FACTOR = exports.GOOGLE_CONVERSION_V3_STAGE_DISCOUNT = exports.GOOGLE_CONVERSION_V3_FORMULA_COEFFICIENTS = exports.GOOGLE_CONVERSION_V3_PIXEL_LEAD_FIXED_VALUE = exports.GOOGLE_CONVERSION_V3_FIXED_VALUE = void 0;
const googleTagManager_1 = require("../origination/googleTagManager");
// REFI is not distinguishable this early in the funnel,
// so the fixed table only splits AC vs MOAP.
exports.GOOGLE_CONVERSION_V3_FIXED_VALUE = {
    [googleTagManager_1.GoogleConversionV3Stage.lead]: { AC: '120', MOAP: '70' },
    [googleTagManager_1.GoogleConversionV3Stage.pii]: { AC: '200', MOAP: '120' },
};
// The frontend pixel fires the lead conversion at the stated-usage step,
// no AC/MOAP split. This is blended lead value
exports.GOOGLE_CONVERSION_V3_PIXEL_LEAD_FIXED_VALUE = '100';
// Formula stages (pq, pqa, booked):
// booked value = lineSize * (apr * aprCoef + lineCoef) - flat   (apr is a decimal, lineSize is dollars)
exports.GOOGLE_CONVERSION_V3_FORMULA_COEFFICIENTS = {
    AC: { aprCoef: '0.8032', lineCoef: '-0.0060', flat: '743' },
    MOAP: { aprCoef: '0.2616', lineCoef: '-0.0057', flat: '752' },
    REFI: { aprCoef: '0.5757', lineCoef: '-0.0068', flat: '1088' },
};
// Discount applied to the booked value to get the per-stage value using conversion.
exports.GOOGLE_CONVERSION_V3_STAGE_DISCOUNT = {
    [googleTagManager_1.GoogleConversionV3Stage.pq]: '0.13',
    [googleTagManager_1.GoogleConversionV3Stage.pqa]: '0.21',
    [googleTagManager_1.GoogleConversionV3Stage.booked]: '1.0',
};
// pq prices line off 75% of the recommended (max) line size.
exports.GOOGLE_CONVERSION_V3_PQ_LINE_SIZE_FACTOR = '0.75';
